import React, { useState, useEffect } from 'react'
import { FullStar, HalfStar, EmptyStar, CreatedAt, ButtonExpandDropdownIconWhite, ButtonCollapseDropdownIconWhite } from "../../../Constants/Icons";
import charmhealthlogo_placeholder from '../../../assets/charmhealthlogo_placeholder.jpg';
import { sortOptions } from '../../../Constants/Data';
import { isUserSignedIn, createReview } from '../../API/API_Handler';
import Message from '../../../Common/Components/Notifications/Notifications';

const Reviews = ({ product, reviews }) => {
    console.log(product, reviews);

    const [sortOption, setSortOption] = useState(sortOptions[0]);
    const [isOptionModalOpen, setIsOptionModalOpen] = useState(false);

    const handleSortOptionChange = (option) => {
        setSortOption(option);
        setIsOptionModalOpen(false);
    }

    const [sortedReviews, setSortedReviews] = useState(reviews);
    const [reviewsLoading, setReviewsLoading] = useState(false);

    async function sortReviews() {
        setReviewsLoading(true);
        let sortedArray;

        if (sortOption === "Newest") {
            sortedArray = [...reviews].sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
        } else if (sortOption === "Oldest") {
            sortedArray = [...reviews].sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
        } else if (sortOption === "Highest Rating") {
            sortedArray = [...reviews].sort((a, b) => b.rating - a.rating);
        } else if (sortOption === "Lowest Rating") {
            sortedArray = [...reviews].sort((a, b) => a.rating - b.rating);
        }

        setSortedReviews(sortedArray);
        setReviewsLoading(false);
    }

    useEffect(() => {
        if (reviews && reviews.length > 0) {
            sortReviews();
        }
    }, [sortOption, reviews]);

    const calculateStarPercentages = (reviews) => {
        const starCounts = [0, 0, 0, 0, 0];
        reviews.forEach(review => {
            if (review.rating >= 1 && review.rating <= 5) {
                starCounts[review.rating - 1]++;
            }
        });
        const totalReviews = reviews.length;
        return starCounts.map(count => (count / totalReviews) * 100);
    };

    const starPercentages = calculateStarPercentages(reviews);
    const [isReviewModalOpen, setIsReviewModalOpen] = useState(false);

    const [renderNotification, setRenderNotification] = useState(false);

    async function handleLeaveReviewButton(isReviewModalOpen) {
        if (isReviewModalOpen) {
            setIsReviewModalOpen(false);
        } else {
            const isSignedIn = await isUserSignedIn();
            if (isSignedIn) {
                setIsReviewModalOpen(true);
            } else {
                setRenderNotification(true);
            }
        }
    }

    const [rating, setRating] = useState(5);
    const [reviewContent, setReviewContent] = useState('');
    const [hoverRating, setHoverRating] = useState(0);

    const [submitReviewLoading, setSubmitReviewLoading] = useState(false);
    const [submitReviewComplete, setSubmitReviewComplete] = useState(false);

    const handleSubmitReview = async () => {
        setSubmitReviewLoading(true);
        await createReview(product.id, product.vendor.id, rating, reviewContent);
        setSubmitReviewLoading(false);
        setSubmitReviewComplete(true);
        await new Promise(resolve => setTimeout(resolve, 5000));
        setIsReviewModalOpen(false);
        setSubmitReviewComplete(false);
        setReviewContent('');
    };

    return (
        <div className="w-full flex flex-col">
            {renderNotification && (
                <Message
                    type="error"
                    duration={5000}
                    message="Please sign in to leave a review!"
                    onClose={() => setRenderNotification(false)}
                />
            )}
            {product && (
                <>
                    {reviews && reviews.length > 0 ? (
                        <div className="w-full flex flex-col">
                            <div className="w-full flex flex-col md:flex-row justify-between">
                                <div className="w-fit flex flex-col">
                                    <div className="w-full flex flex-row">
                                        <h4 className="font-allroundgothic text-[18px] md:text-[22px] font-[600] mb-0">
                                            Reviews
                                        </h4>
                                    </div>

                                    {product.rating && product.rating <= 5 && product.rating >= 0 && (
                                        <div className="mt-[16px] w-fit flex flex-row items-center">
                                            {[...Array(Math.floor(product.rating))].map((_, index) => (
                                                <FullStar key={`full-${index}`} />
                                            ))}
                                            {(() => {
                                                const decimal = product.rating - Math.floor(product.rating);
                                                let partialStar = null;
                                                if (decimal > 0 && decimal <= 0.3) {
                                                    partialStar = <EmptyStar key="empty" />;
                                                } else if (decimal > 0.3 && decimal <= 0.7) {
                                                    partialStar = <HalfStar key="half" />;
                                                } else if (decimal > 0.7) {
                                                    partialStar = <FullStar key="partial-full" />;
                                                }
                                                return partialStar;
                                            })()}
                                            {[...Array(5 - Math.ceil(product.rating))].map((_, index) => (
                                                <EmptyStar key={`empty-${index}`} />
                                            ))}
                                            <p className="font-proximanova font-[500] text-[18px] ml-3 my-0">{product.rating}</p>
                                            <p className="font-proximanova font-[500] text-[18px] ml-3 my-0">({reviews.length})</p>
                                        </div>
                                    )}

                                    <div className="w-full mt-[16px]">
                                        {[5, 4, 3, 2, 1].map((star, index) => (
                                            <div key={star} className="w-[360px] flex flex-row items-center">
                                                <p className="w-[50px] font-proximanova font-[500] text-[16px] mb-0">{star} star</p>
                                                <div className="flex-1 bg-white h-[8px] ml-2 rounded-full">
                                                    <div
                                                        className="bg-[#F2A83B] h-full rounded-full"
                                                        style={{ width: `${starPercentages[star - 1]}%` }}
                                                    ></div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                <div className="w-fit flex flex-col">
                                    <div className="mt-[16px] md:mt-[0px] w-full flex md:justify-end">
                                        <button className="w-fit h-fit px-8 py-2 1.5xl:px-10 1.5xl:py-4 font-proximanova text-white text-[18px] bg-charmOrange hover:text-integrationRequestTextHover rounded-full flex flex-row items-center" onClick={() => setIsOptionModalOpen(!isOptionModalOpen)}>
                                            {sortOption}
                                            {isOptionModalOpen ?
                                                <ButtonExpandDropdownIconWhite />
                                                :
                                                <ButtonCollapseDropdownIconWhite />
                                            }
                                        </button>
                                    </div>

                                    {isOptionModalOpen && (
                                        <div className="mt-[16px] w-fit flex flex-col border-[1px] border-charmHover">
                                            {sortOptions.map(option => (
                                                <button className="w-full px-[100px] py-[4px] font-proximanova font-[500] text-[18px] text-[#505050] mb-0 hover:bg-charmHover hover:text-white" key={option} onClick={() => handleSortOptionChange(option)}>
                                                    {option}
                                                </button>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className="mt-[16px] flex flex-col gap-[20px]">
                                {reviewsLoading ? (
                                    <div className="flex flex-col gap-[8px]">
                                        <div className="flex flex-col gap-[8px]">
                                            <p className="font-proximanova text-[18px] font-[600] text-[#505050] mb-0">Loading...</p>
                                        </div>
                                    </div>
                                ) : (
                                    sortedReviews.map((review) => (
                                        <div className="flex flex-col gap-[8px]">
                                            <div className="flex flex-col gap-[8px]">
                                                <p className="font-proximanova text-[18px] font-[600] text-[#505050] mb-0">{review.practice_user_name}</p>
                                                <div className="flex flex-row">
                                                    {[...Array(review.rating)].map((_, index) => (
                                                        <FullStar />
                                                    ))}
                                                    {[...Array(5 - review.rating)].map((_, index) => (
                                                        <EmptyStar />
                                                    ))}
                                                </div>
                                            </div>
                                            <p className="font-proximanova text-[18px] text-[#505050] mb-0">{review.comment}</p>
                                            <div className="flex flex-row items-center">
                                                <CreatedAt />
                                                <p className="ml-[4px] font-proximanova text-[15px] text-[#505050] italic mb-0">{new Date(review.created_at).toLocaleDateString()}</p>
                                            </div>

                                            {review.vendor_response &&
                                                <div className="ml-[32px] flex flex-col border-l border-charmHover">
                                                    <div className="ml-[16px] mt-[4px] flex flex-row items-center">
                                                        <div className="h-10 w-10 bg-charmHover rounded-full border border-charmHover">
                                                            <img
                                                                src={
                                                                    product && (product.thumbnail.includes('s3.amazonaws.com') || product.thumbnail.includes('.amazonaws.com'))
                                                                        ? product.thumbnail
                                                                        : charmhealthlogo_placeholder
                                                                }
                                                                className="min-w-10 min-h-10 max-w-10 max-h-10"
                                                            />
                                                        </div>
                                                        <p className="ml-[16px] font-proximanova text-[18px] font-[600] text-[#505050] mb-0">{product.vendor.company_name}</p>
                                                    </div>
                                                    <p className="mt-[4px] ml-[16px] font-proximanova text-[18px] text-[#505050] mb-0" style={{ lineHeight: '1.35' }}>{review.vendor_response}</p>
                                                </div>
                                            }
                                        </div>
                                    ))
                                )}
                            </div>
                        </div>
                    ) : (
                        <p className="w-fit font-proximanova text-[18px] mb-0">No reviews yet for this product</p>
                    )}

                    <div className="mt-[24px] w-full flex justify-center">
                        <button className='w-fit h-fit mx-auto text-white bg-link hover:text-integrationRequestTextHover hover:bg-charmHover rounded-full text-[18px] font-proximanova px-8 py-2 1.5xl:px-10 1.5xl:py-4' onClick={() => handleLeaveReviewButton(isReviewModalOpen)}>
                            Leave a Review
                        </button>
                    </div>

                    <div
                        className={`fixed inset-0 z-50 ${isReviewModalOpen ? 'flex' : 'hidden'} items-center justify-center bg-black bg-opacity-50`}
                    >
                        <div className="w-full max-w-[640px] h-fit flex flex-col bg-white p-[32px]">
                            <div className="w-full flex flex-row items-center justify-between">
                                <h5 className="font-proximanova text-[20px] md:text-[24px] font-[600] text-[#505050] mb-0">Leave a Review</h5>
                                <button
                                    type="button"
                                    className="font-proximanova text-[28px] md:text-[32px] font-[600] text-[#505050] mb-0 hover:text-gray-500 focus:outline-none"
                                    onClick={() => setIsReviewModalOpen(false)}
                                >
                                    <span className="sr-only">Close</span>
                                    &times;
                                </button>
                            </div>

                            {submitReviewLoading ? (
                                <div className="min-h-[20rem] w-full flex flex-col items-center justify-center">
                                    <div className="spinner-border" role="status">
                                    </div>
                                    <p className="mt-[16px] font-proximanova text-[18px] font-[600] text-[#505050] text-center mb-0">Hang tight — we're submitting your review!</p>
                                </div>
                            ) : (submitReviewComplete ? (
                                <div className="min-h-[20rem] w-full flex flex-col items-center justify-center">
                                    <p className="font-proximanova text-[18px] font-[600] text-[#505050] text-center mb-0">Your review has been submitted successfully! Thank you for your feedback!</p>
                                </div>
                            ) : (
                                <div className="min-h-[20rem] w-full flex flex-col">
                                    <div className="w-full flex flex-col">
                                        <label className="w-full text-left font-proximanova font-[600] text-[18px] text-[#505050] mb-1 ">Rating</label>
                                        <div className="w-full flex flex-row items-center">
                                            {[1, 2, 3, 4, 5].map((star) => (
                                                <div
                                                    key={star}
                                                    onClick={() => setRating(star)}
                                                    className="cursor-pointer"
                                                    onMouseEnter={() => setHoverRating(star)}
                                                    onMouseLeave={() => setHoverRating(0)}
                                                >
                                                    {star <= (hoverRating || rating) ? (
                                                        <FullStar />
                                                    ) : (
                                                        <EmptyStar />
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                    <div className="mt-[8px] w-full flex flex-col">
                                        <label className="w-full text-left font-proximanova font-[600] text-[18px] text-[#505050] mb-1 ">Review</label>
                                        <textarea
                                            className="w-full h-48 block p-1 bg-white font-proximanova text-[18px] border-[1px] border-[#505050] focus:border-charmOrange focus:outline-none"
                                            value={reviewContent}
                                            onChange={(e) => setReviewContent(e.target.value)}
                                            placeholder="Write your review here...">
                                        </textarea>
                                    </div>

                                    <div className="mt-[12px] w-full flex flex-row justify-end gap-[12px]">
                                        <button
                                            className="text-white text-[18px] font-proximanova px-[24px] py-[3px] bg-[#fd5764] hover:text-integrationRequestTextHover hover:bg-charmHover w-fit rounded-full"
                                            onClick={() => setIsReviewModalOpen(false)}>
                                            Cancel
                                        </button>

                                        <button
                                            className="text-white text-[18px] font-proximanova px-[24px] py-[3px] bg-[#76da24] hover:text-integrationRequestTextHover hover:bg-charmHover w-fit rounded-full"
                                            onClick={() => handleSubmitReview()}>
                                            Submit
                                        </button>
                                    </div>
                                </div>
                            ))}

                        </div>
                    </div>
                </>
            )}
        </div>
    )
}

export default Reviews